import Vue from 'vue';
import VueInternationalization from 'vue-i18n';
import './cleanUtilities.js';

import Modal from './components/Modal.vue';
import IconTextContainer from './components/Layout/IconTextContainer.vue';
import LoadingAnimation from './components/LoadingAnimation.vue';
import NovaDatePicker from './components/NovaDatePicker.vue';
import LicensePlateInput from './components/LicensePlateInput.vue';
import CustomerReviews from './components/CustomerReviews.vue';
import Price from './components/Price.vue';

Vue.use(VueInternationalization);

Vue.component('icon-text-container', IconTextContainer);
Vue.component('modal', Modal);
Vue.component('loading-animation', LoadingAnimation);
Vue.component('nova-datepicker', NovaDatePicker);
Vue.component('license-plate-input', LicensePlateInput);
Vue.component('customer-reviews', CustomerReviews);
Vue.component('price', Price);

export function initializeApp(selector = '#app', components) {
    const i18n = new VueInternationalization({
        locale: Vue.prototype.$language,
        messages: typeof locales === 'object' ? locales : {},
        fallbackLocale: 'en',
    });

    return new Vue({
        el: selector,
        i18n,
        components,
    });
}
